import { IonContent, IonHeader, IonPage, IonList, IonLabel, IonItem, IonTitle, IonToolbar, IonButtons, IonBackButton, IonNote, IonModal, IonButton, IonGrid, IonRow, IonCol, IonAlert, IonSearchbar, IonSelect, IonSelectOption, IonSpinner, IonCheckbox } from '@ionic/react';
import React, { useState, useEffect } from 'react';
import Product from './Product';
import { getProduct, getOrder, markOrder, getOrders, getOrdersByName, getOrdersBySearch } from '../ServerProvider';
import CartButton from './Cart';
import { IconButton } from './Products';

export const get = (id: string) => {
    return window.localStorage.getItem(id) ? window.localStorage.getItem(id) as string : ""
}

const Orders: React.FC<{ warehouse: boolean }> = (props) => {

    const [showProduct, setShowProduct] = useState(-1)
    const [showAlert, setShowAlert] = useState(false)
    const [showAlert2, setShowAlert2] = useState(false)
    const [products, setProducts] = useState([] as any[])
    const [orderStatus, setOrderStatus] = useState('unfulfilled')
    const [orders, setOrders] = useState([] as any[])
    const [searchKeyword, setSearchKeyword] = useState('')
    const [filterStatus, setFilterStatus] = useState('unfulfilled')
    const [loading, setLoading] = useState(false)
    const [hasMore, setHasMore] = useState(true)
    const [showFieldsModal, setShowFieldsModal] = useState(false)
    const [visibleFields, setVisibleFields] = useState({
        timestamp: true,
        jobName: true,
        jobNumber: true,
        name: false,
        location: false,
        pmName: false,
        dateNeeded: false,
        uuid: false,
        deliveryInstructions: false,
        company: false
    })

    const gOrders = (async (reset: boolean = false) => {
        if (loading) return;

        setLoading(true);
        const skip = reset ? 0 : orders.length;
        const limit = 50;

        try {
            if (props.warehouse) {
                const res = await getOrdersBySearch(filterStatus, searchKeyword, skip, limit);
                const processedItems = res.items.map((item: any) => ({
                    ...item,
                    order: item.products
                }));

                if (reset) {
                    setOrders(processedItems);
                } else {
                    setOrders(prev => [...prev, ...processedItems]);
                }

                setHasMore(processedItems.length === limit);
            } else {
                const res = await getOrdersByName(get("name"), skip, limit);
                const processedItems = res.map((item: any) => ({
                    ...item,
                    order: item.products
                }));

                if (reset) {
                    setOrders(processedItems);
                } else {
                    setOrders(prev => [...prev, ...processedItems]);
                }

                setHasMore(processedItems.length === limit);
            }
        } catch (error) {
            console.error('Error loading orders:', error);
        } finally {
            setLoading(false);
        }
    });

    useEffect(() => {
        gOrders(true);
    }, [searchKeyword, filterStatus]);

    const sShowProduct = async (set: boolean, i: number = -1) => {
        if (set) {
            console.log(orders)
            const iProducts = []
            for (let product of orders[i].order) {
                try {
                    const result = await getProduct(product.sku)

                    result.quantity = product.quantity

                    iProducts.push(result)
                } catch { }
            }
            setProducts(iProducts)

            const order = await getOrder(orders[i].uuid)
            setOrderStatus(order.status || 'unfulfilled')
            setShowProduct(i)
        } else {
            setShowProduct(-1)
            setProducts([])
        }
    }

    const reOrder = (order: any) => {
        window.localStorage.setItem("cart", JSON.stringify({ items: order }))
        setShowAlert(true)
    }

    const markOrderAs = (uuid: string, status: string) => {
        markOrder(uuid, status).then(() => {
            setOrderStatus(status)
            setShowAlert2(true)
        })
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle color="primary">Orders</IonTitle>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonButtons slot="end">
                        {props.warehouse && (
                            <IonButton fill="clear" onClick={() => setShowFieldsModal(true)}>
                                Change Preview
              </IonButton>
                        )}
                        <IconButton />
                        {props.warehouse ? null : <CartButton />}
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                {props.warehouse && (
                    <>
                        <IonSearchbar
                            value={searchKeyword}
                            onIonChange={(e) => setSearchKeyword(e.detail.value!)}
                            onIonClear={() => setSearchKeyword('')}
                            placeholder="Search orders by name, location, job name, job number, PM name, delivery instructions, company or UUID"
                            debounce={300}
                        />
                        <IonItem>
                            <IonLabel>Filter by Status</IonLabel>
                            <IonSelect
                                value={filterStatus}
                                placeholder="All statuses"
                                onIonChange={(e: any) => setFilterStatus(e.detail.value)}
                            >
                                <IonSelectOption value={null}>All statuses</IonSelectOption>
                                <IonSelectOption value="unfulfilled">Unfulfilled</IonSelectOption>
                                <IonSelectOption value="shipped">Shipped</IonSelectOption>
                                <IonSelectOption value="complete">Complete</IonSelectOption>
                            </IonSelect>
                        </IonItem>
                    </>
                )}
                <IonAlert isOpen={showAlert} header="Added to cart" message="To reorder, place the order in the cart." buttons={['Okay']} onDidDismiss={() => setShowAlert(false)}></IonAlert>
                <IonAlert isOpen={showAlert2} header="Order status updated" buttons={['Okay']} onDidDismiss={() => setShowAlert2(false)}></IonAlert>
                <IonList>
                    {orders.map((order: { timestamp: number, order: any[], uuid: string, name: string, location: string, jobName: string, dateNeeded: string, pmName: string, jobNumber: string, deliveryInstructions: string, company: string | null }, i: number) => {
                        return <>
                            <IonItem detail={true} key={i} onClick={() => sShowProduct(true, i)}>
                                <IonLabel>
                                    {[
                                        visibleFields.timestamp && (new Date(order.timestamp * 1000).toLocaleDateString() + " " + new Date(order.timestamp * 1000).toLocaleTimeString()),
                                        visibleFields.name && order.name,
                                        visibleFields.location && order.location,
                                        visibleFields.jobName && order.jobName,
                                        visibleFields.jobNumber && order.jobNumber,
                                        visibleFields.pmName && order.pmName,
                                        visibleFields.dateNeeded && order.dateNeeded,
                                        visibleFields.uuid && order.uuid,
                                        visibleFields.deliveryInstructions && order.deliveryInstructions,
                                        visibleFields.company && order.company
                                    ].filter(Boolean).join(" — ")}
                                </IonLabel>
                                <IonNote slot="end">
                                    {order.order.length + " products"}
                                </IonNote>

                            </IonItem>
                            <IonModal isOpen={showProduct === i} onDidDismiss={() => setShowProduct(-1)}>
                                <IonToolbar>
                                    <IonTitle>{`${order.order.length} ${order.order.length === 1 ? "product" : "products"}`}</IonTitle>
                                    <IonButtons slot="primary">
                                        <IonButton onClick={() => sShowProduct(false, -1)}>Close</IonButton>
                                    </IonButtons>
                                    <IonButtons slot="start">
                                        {props.warehouse ? (
                                            <>
                                                <IonButton onClick={() => { markOrderAs(order.uuid, 'shipped') }}>Mark as Shipped</IonButton>
                                                <IonButton onClick={() => { markOrderAs(order.uuid, 'complete') }}>Mark as Complete</IonButton>
                                            </>
                                        ) : <IonButton onClick={() => { reOrder(order.order) }}>Reorder</IonButton>}
                                    </IonButtons>
                                </IonToolbar>
                                <IonContent>
                                    <IonList>
                                        <IonItem>
                                            <IonLabel>Status </IonLabel>
                                            <IonNote>{orderStatus.charAt(0).toUpperCase() + orderStatus.slice(1)}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>UUID </IonLabel>
                                            <IonNote>{order.uuid}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Name </IonLabel>
                                            <IonNote>{order.name}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Delivery Address </IonLabel>
                                            <IonNote>{order.location}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Job Name </IonLabel>
                                            <IonNote>{order.jobName}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Date Needed</IonLabel>
                                            <IonNote>{order.dateNeeded}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>PM Name </IonLabel>
                                            <IonNote>{order.pmName}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Job Number</IonLabel>
                                            <IonNote>{order.jobNumber}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Delivery Instructions</IonLabel>
                                            <IonNote>{order.deliveryInstructions}</IonNote>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Company</IonLabel>
                                            <IonNote>{order.company}</IonNote>
                                        </IonItem>

                                    </IonList>
                                    <IonGrid>
                                        <IonRow>
                                            {order.order.map((item, key) => <IonCol key={key} size="6"><Product product={products.length > key ? products[key] : item} warehouse={false} qcHandler={null} readOnly={true} noImages={true}></Product></IonCol>)}
                                        </IonRow>
                                    </IonGrid>
                                </IonContent>
                            </IonModal>
                        </>
                    })}
                    {hasMore && (
                        <IonItem>
                            <IonButton
                                fill="clear"
                                onClick={() => gOrders(false)}
                                disabled={loading}
                            >
                                {loading ? <IonSpinner name="crescent" /> : 'Load More Orders'}
                            </IonButton>
                        </IonItem>
                    )}
                </IonList>

                <IonModal isOpen={showFieldsModal} onDidDismiss={() => setShowFieldsModal(false)}>
                    <IonHeader>
                        <IonToolbar>
                            <IonTitle>Display Fields</IonTitle>
                            <IonButtons slot="primary">
                                <IonButton onClick={() => setShowFieldsModal(false)}>Done</IonButton>
                            </IonButtons>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent>
                        <IonList>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.timestamp}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, timestamp: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>Timestamp</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.name}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, name: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>Name</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.location}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, location: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>Location</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.jobName}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, jobName: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>Job Name</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.jobNumber}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, jobNumber: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>Job Number</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.pmName}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, pmName: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>PM Name</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.dateNeeded}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, dateNeeded: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>Date Needed</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.uuid}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, uuid: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>UUID</IonLabel>
                            </IonItem>
                            <IonItem>
                                <IonCheckbox
                                    checked={visibleFields.deliveryInstructions}
                                    onIonChange={(e) => setVisibleFields(prev => ({ ...prev, deliveryInstructions: e.detail.checked }))}
                                />
                                <IonLabel style={{ marginLeft: '10px' }}>Delivery Instructions</IonLabel>
                            </IonItem>
                        </IonList>
                    </IonContent>
                </IonModal>
            </IonContent>
        </IonPage>
    );
};

export default Orders;
